import script from "./LegalStatusPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalStatusPage.vue?vue&type=script&setup=true&lang=js"

import "./LegalStatusPage.vue?vue&type=style&index=0&id=30c4b752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c4b752"]])

export default __exports__